import { formatSupportRoleNames } from 'src/supportPortal/access/accessMatrix'
import {
  getSPDataWithParams,
  postSPDataWithoutParams,
  putSPDataWithoutParams,
} from 'src/supportPortal/services/services'

const SUPPORT_BOOKED_EVENT_RESCHEDULE_API = '/api/secure/cc/support/events/actions/reschedule'
const SUPPORT_BOOKED_EVENT_CANCEL_API = '/api/secure/cc/support/events/actions/cancel'

export function fetchSupportBookedEventDaySlots({
  mentorId,
  selectedDate,
}) {
  return getSPDataWithParams('/api/secure/cc/support/events/actions/booked-slots/all-with-patient-info', {
    mentorId,
    startTime: selectedDate.startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
    endTime: selectedDate.endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
    includeBlocked: true,
  })
}

export function rescheduleSupportBookedEvent(request) {
  return putSPDataWithoutParams(SUPPORT_BOOKED_EVENT_RESCHEDULE_API, request)
}

export function cancelSupportBookedEvent(request) {
  return postSPDataWithoutParams(SUPPORT_BOOKED_EVENT_CANCEL_API, request)
}

export function extractSupportBookedEventActionErrorPayload(response) {
  return response?.data || response?.response?.data || null
}

export function buildSupportBookedEventActionErrorMessage(
  response,
  fallbackMessage = 'This action could not be completed',
) {
  const payload = extractSupportBookedEventActionErrorPayload(response)
  const payloadData = payload?.data || payload?.payload || {}
  const allowedRoles = Array.isArray(payloadData?.allowedRoles) ? payloadData.allowedRoles : []

  if (allowedRoles.length > 0) {
    const roleText = formatSupportRoleNames(allowedRoles)
    const baseMessage =
      payload?.message || 'You do not have the roles allowed to perform this action.'
    return `${baseMessage}. Allowed roles: ${roleText}`
  }

  return payload?.message || fallbackMessage
}
